import { useState } from "react";
import { BookmarkPlus, Loader2, Check } from "lucide-react";
import { api } from "../lib/api";

function urlBase64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const safe = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(safe);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

/**
 * One-tap: snapshot the current filter state into a permanent push subscription.
 * If push permission isn't granted yet, asks for it first.
 */
export default function SaveSearchButton({ criteria, label }) {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  async function save() {
    setBusy(true); setErr("");
    try {
      if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        throw new Error("Push notifications aren't supported in this browser.");
      }
      const perm = await Notification.requestPermission();
      if (perm !== "granted") throw new Error("Allow notifications to save searches.");

      const { data: keyResp } = await api.get("/push/public-key");
      if (!keyResp?.public_key) throw new Error("Push isn't configured yet.");
      const reg = await navigator.serviceWorker.ready;
      let sub = await reg.pushManager.getSubscription();
      if (!sub) {
        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(keyResp.public_key),
        });
      }
      await api.post("/push/subscribe", {
        subscription: sub.toJSON(),
        criteria: { ...criteria, label: label || criteria.label || "Just Listed alerts" },
      });
      setDone(true);
      setTimeout(() => setDone(false), 4000);
    } catch (e) {
      setErr(e?.response?.data?.detail || e?.message || "Couldn't save search.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="inline-flex items-center gap-2" data-testid="save-search">
      <button
        type="button"
        onClick={save}
        disabled={busy}
        className="ssc-btn ssc-btn-secondary text-sm"
        data-testid="save-search-button"
      >
        {busy ? <Loader2 size={14} className="animate-spin" /> :
         done  ? <Check size={14} /> :
                 <BookmarkPlus size={14} />}
        {busy ? "Saving…" : done ? "Saved — you'll get pushes" : "Save this search"}
      </button>
      {err && <span className="text-xs text-[var(--ssc-red)] font-bold">{err}</span>}
    </div>
  );
}
